import D1 from '../../components/ExcerciseTypes/Design/TypeIn';


const json = {


  1: { // Exercise num
    unit: 'Unit 8',
    id: 'WB4-V2-U8-P55-E1',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page55/E1/Key/answerKey.png',
    checkUppercase: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page55/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page55/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page55/E1/3.jpg', input: true, answer: "Put on your sun hats." },
        { url: 'img/FriendsPlus/Page55/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page55/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page55/E1/6.jpg', input: true, answer: "Don't put on your coat." },
        { url: 'img/FriendsPlus/Page55/E1/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page55/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page55/E1/9.jpg', input: true, answer: "We don't have our umbrellas." },
        { url: 'img/FriendsPlus/Page55/E1/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page55/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page55/E1/12.jpg', input: true, answer: "Don't close the window." },
        { url: 'img/FriendsPlus/Page55/E1/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page55/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page55/E1/15.jpg', input: true, answer: "Open the door." },
        { url: 'img/FriendsPlus/Page55/E1/16.jpg' },
      ],


    ]
  },
  2: { // Exercise num
    unit: 'Unit 8',
    id: 'WB4-V2-U8-P55-E2',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page55/E2/Key/answerKey.png',
    checkUppercase: true,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page55/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page55/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page55/E2/3.jpg', input: true, answer: "Put on" },
        { url: 'img/FriendsPlus/Page55/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page55/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page55/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page55/E2/7.jpg', input: true, answer: "Put on" },
        { url: 'img/FriendsPlus/Page55/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page55/E2/9.jpg', input: true, answer: "Don't put on" },
        { url: 'img/FriendsPlus/Page55/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page55/E2/11.jpg' },
      ],

    ]
  },
}
export default json;